export enum CampagneModelStep {
  SEARCH_INDUSTRIAL = 'SEARCH_INDUSTRIAL',
  ADD_QUANTITY = 'ADD_QUANTITY',
  SHOW_DETAILS = 'SHOW_DETAILS',
}
